import PpPageviewSender from './PpPageviewSender';

export default PpPageviewSender;
